import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { EventEmitter } from '@angular/core';

import * as _ from 'lodash';

export interface Choice {
  id: string;
  label: string;
  checked?: boolean;
  disabled?: boolean;
  color?: string;
}

@Component({
    selector: 'pr-radio',
    templateUrl: './pr-radio.component.html',
    styleUrls: ['./pr-radio.component.scss'],
    standalone: false
})
export class PrRadioComponent implements AfterViewInit {
  @Input() set choices(choices: Choice[]) {
    if (!choices?.length) return;
    this._choices = [];
    choices.forEach((item, i) =>
      this._choices.push({
        id: item[0] || item.id,
        label: item[1] || item.label,
        checked: i == 0 ? true : false,
        disabled: item[3] || item.disabled || false,
        color: item.color || 'default',
      }),
    );
  }
  get choices() {
    return this._choices;
  }
  @Output() onSelectChoice: EventEmitter<any> = new EventEmitter();
  _choices: any[] = [];

  @Input() filterProperty;
  @Input() defaultValue;
  _list;
  @Input() set list(val) {
    this._list = val;
    this.filterList(this.choices.find(c => c.checked));
  }
  get list() {
    return this._list;
  }

  _listFiltered;
  get listFiltered() {
    return this._listFiltered;
  }
  @Input() set listFiltered(val) {
    this._listFiltered = val;
    this.listFilteredChange.emit(val);
  }
  @Output() listFilteredChange = new EventEmitter();

  hash =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  @ViewChild('selected', { static: false }) selected: ElementRef;
  @ViewChildren('selected') labels: QueryList<ElementRef<HTMLLabelElement>>;

  get indicatorLabel(): HTMLLabelElement | undefined {
    const checkedIndex = this._choices.findIndex(choice => choice.checked);
    return this.labels?.get(checkedIndex)?.nativeElement;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewInit() {
    if (this.defaultValue) {
      let choice = this.choices.find(item => item.id === this.defaultValue);
      let selectedElement = new ElementRef(
        document.querySelector(
          `label[for="${this.defaultValue}_${this.hash}"]`,
        ),
      );
      this.selected = selectedElement;
      this.check(choice);
      this.onSelectChoice.emit(choice);
    }
    if (this.selected) {
      (this.selected.nativeElement as HTMLLabelElement).control?.click();
    }
    this.labels.changes.subscribe(() => this.checkIndicatorControl());
    this.changeDetectorRef.detectChanges();
  }

  private checkIndicatorControl() {
    const control = this.indicatorLabel?.control as HTMLInputElement | null;
    if (control) control.checked = true;
  }

  handleChange(evt, choice) {
    this.selected = evt.target.nextElementSibling;
    this.check(choice);
    this.onSelectChoice.emit(choice);
    this.filterList(choice);
  }

  filterList(choice) {
    if (!this.filterProperty || choice.id == 'all')
      return (this.listFiltered = this.list);
    this.listFiltered = this.list.filter(item => {
      if (typeof item[this.filterProperty] == 'object')
        return item[this.filterProperty]
          ?.toLowerCase()
          .includes(choice.id?.toLowerCase());
      else
        return (
          item[this.filterProperty]?.toLowerCase() == choice.id?.toLowerCase()
        );
    });
  }

  check(choice) {
    let previousChoice = this._choices.find(c => c.checked);
    if (previousChoice) previousChoice.checked = false;
    choice.checked = true;
  }

  getSelectedChoiceClass(): string {
    const selectedChoice = this._choices.find(choice => choice.checked);
    return selectedChoice ? selectedChoice.color : 'default';
  }
}
